import { __makeTemplateObject } from '../../../../node_modules/tslib/tslib.es6.js';
import styled from 'styled-components';
var StyledHeading = styled.h1(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
export { StyledHeading };